/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

import _, { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
// material
import { Card, CardHeader, Box, Button } from "@mui/material";
//
import { BaseOptionChart } from "../../components/charts";
import moment from "moment";
import React from "react";
import "./style/chart2.css";

// ----------------------------------------------------------------------

export default function MessagesChartBroadcast(props) {
  const { labels, values } = props;
  // console.log("HERE", labels, values);
  let dateFormat = "DD MMM YYYY";
  const [chartData, setChartData] = React.useState([]);

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [2, 2, 2] },
    plotOptions: { bar: { columnWidth: "11%", borderRadius: 4 } },
    fill: { type: ["solid", "solid", "solid"] },
    labels: labels,
    xaxis: {
      // type: "datetime",
      categories: labels,
      labels: {
        // format: 'dd MMM HH:mm',
        formatter: function (y) {
          return new moment(y).format(dateFormat);
        },
      },
    },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   x: {
    //     show: true,
    //     formatter: function (y) {
    //       return new moment(y).format(dateFormat);
    //     },
    //   },
    //   y: {
    //     formatter: (y) => {
    //       if (typeof y !== "undefined") {
    //         return `${y.toFixed(0)}`;
    //       }
    //       return y;
    //     },
    //   },
    //   items: {
    //     display: "flex",
    //   },
    // },
    // tooltip: {
    //   shared: true,
    //   intersect: false,
    //   x: {
    //     show: true,
    //     formatter: function (seriesName) {
    //       return seriesName;
    //     },
    //   },
    //   y: {
    //     formatter: (seriesName) => {
    //       if (typeof y !== "undefined") {
    //         return `${seriesName.toFixed(0)}`;
    //       }
    //       return seriesName;
    //     },
    //   },
    //   items: {
    //     display: "flex",
    //   },
    // },
  });
  // console.log("obj", values);

  React.useEffect(() => {
    const mappData = (values) => {
      let attribute;
      let finalObj = {};
      let finallArr = [];
      if (values.length !== 0) {
        attribute = values[0];
        let arrAttribute = Object.keys(attribute);
        // console.log("arrAttribute", arrAttribute);

        // for(let obj in arrAttribute){

        arrAttribute.forEach((item) => {
          // arrAttribute.forEach((element) => {
          finalObj["name"] = item;
          finalObj["type"] = "line";
          finalObj["data"] = values.map((obj) => obj[item]);
          finallArr.push(finalObj);
          finalObj = {};
          // });
        });
        // }
        setChartData(finallArr);
      }
    };

    let map = true;

    if (map) mappData(values);

    return () => {
      map = false;
    };
  }, [values]);

  // const CHART_DATA = [
  //   {
  //     name: "User",
  //     type: "line",
  //     data: values.map((obj) => obj.user),
  //   },
  //   {
  //     name: "Business",
  //     type: "line",
  //     data: values.map((obj) => obj.business),
  //   },
  // ];

  const downloadData = async () => {
    let unzippedMessagesData = [];
    for (let idx in labels) {
      unzippedMessagesData.push({
        label: labels[idx],
        values: values[idx],
      });
    }
    // console.log(unzippedMessagesData);

    const convertToDate = (param) => {
      let momentDate = moment(param.label);
      momentDate.set({ hour: 10, minute: 0 });
      return momentDate.format("DD MMM YYYY");
    };

    let groupedMessageData = _.groupBy(unzippedMessagesData, convertToDate);
    // console.log(groupedMessageData);

    let resultJSON = [];
    let downloadAttribute = {};
    for (let rawDate of Object.keys(groupedMessageData)) {
      let dayData = groupedMessageData[rawDate];

      for (let datum of dayData) {
        let keyattr = Object.keys(datum.values);
        for (let datum2 of keyattr) {
          downloadAttribute[datum2] = datum.values[datum2];
        }
      }
      resultJSON.push({
        date: rawDate,
        ...downloadAttribute,
      });
    }

    let dataHeader = Object.keys(downloadAttribute)
      .map((item) => item)
      .join(";");
    let header = `date;` + dataHeader;
    let body = "";
    for (let rj of resultJSON) {
      body += `\n${rj.date};${rj["total read"]};${rj["total sent"]};${rj["total delivered"]}`;
    }

    let csvText = header + body;

    const element = document.createElement("a");
    const file = new Blob([csvText], { type: "text/csv;charset=utf-8" });
    element.href = URL.createObjectURL(file);
    element.download = "broadcast_data_export.csv";
    document.body.appendChild(element);
    element.click();
  };

  return (
    <Card>
      <CardHeader title="Broadcast" />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          paddingRight: 20,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            downloadData();
          }}
        >
          Download
        </Button>
      </div>
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="line"
          series={chartData}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}
